import { dynamicElementsHotListIndicatorKey } from '@epicuro-next/constants/dynamic-elements';
import { OPENED_LIST_DATA_PROVIDER_KEY } from '@epicuro-next/data-providers/providers-registry';
import { IDynamicItem } from '@epicuro-next/models/platform/dynamic-elements/dynamic-elements';

export const hotListIndicatorItem: IDynamicItem = {
  contentTypeId: dynamicElementsHotListIndicatorKey,
  inputs: {
    listIds: {
      provider: OPENED_LIST_DATA_PROVIDER_KEY,
      property: 'id',
    },
    showAlmostHotIconBasedOnUserRole: true,
  },
};
